import axios from 'axios';

export function getMobileAppSettings() {
  return axios.get('/Config/MobileAppSettings');
}

export function checkAppLogo(url) {
  return axios.get(url);
}
